export default __webpack_public_path__ + "static/media/ic-certificado.2d05b3f9.svg";